<template>
	<div class="EventsScreen">
		<div class="Wrapper">
			<SplideWrapper v-if="upcomingEvents.length" :items="upcomingEvents" title="Próximos partidos" type="Events"
				:useArrows="false" description="En directo en YouTube" :heightAuto="false"
				:contentSize="{ width: 231, height: 410 }" :customSpliderOptions="customSpliderOptions">
			</SplideWrapper>
		</div>
	</div>
</template>

<script>
import { mediaQueryMixin } from "@/mixins";
import moment from "moment";
import { SplideWrapper, SectionWrapper } from '@/components'
import { events } from '@/utils/events'

export default {
	name: "EventsScreen",
	components: {
		SplideWrapper,
		SectionWrapper
	},
	mixins: [mediaQueryMixin],
	data() {
		return {
			events,
		};
	},
	computed: {
		customSpliderOptions() {
			return {
				// perMove: 1,
				// width: "100%",
				// gap: "2rem",
				// perPage: this.perPage,
				pagination: false,
				// autoplay: true,
				// interval: 8000,
				// type: "loop",
				// start: 2,
				// arrows: this.useArrows,
				// focus: 'center',
				// autoWidth: this.autoWidthProp,
				direction: 'ttb',
				height: '20rem',
			}
		},
		upcomingEvents() {
			const events = this.events.filter(e => !this.isPastDate(e.date))
			return events.reverse()
		},
	},
	methods: {
		isPastDate(date) {
			const today = moment();
			return moment(date).isBefore(today);
		},
	},
};
</script>
<style lang="scss" scoped>
@font-face {
	font-family: 'adonais';
	src: url('~@/assets/fonts/Adonais.ttf') format('truetype');
}

.EventsScreen {
	width: 100%;
	min-height: 100vh;
	background: #333;

	.Wrapper {
		display: flex;
		flex-direction: column;
		align-items: center;
		position: relative;
		margin-top: 6rem;


		&::v-deep .splide__track {
			height: 800px !important;
			margin-left: 4rem;

			@media screen and (max-width: $md) {
				margin-left: 2rem;
			}

			.splide__slide {
				width: 26rem !important;

				@media screen and (max-width: $sm) {
					width: 20rem !important;
				}
			}
		}

	}

}
</style>
